import React from 'react';
import { inject, observer } from 'mobx-react';
import QRCode from 'qrcode.react';
import { addContentPath } from '../../../../util/pathUtil';

@inject('portalLoginStore')
@observer
class SimpleQRCode extends React.Component {
    constructor(props) {
        super(props);
        this.onRefresh = this.onRefresh.bind(this);
        this.onDownload = this.onDownload.bind(this);
    }

    componentDidMount() {
        const { portalLoginStore,getState } = this.props;
        let { state = {} } = portalLoginStore;
        state = getState();
        const { loginSettingInfo = {} } = state;
        const { loginInfo, loginForm } = loginSettingInfo;
        const {qrcodeValidTime = 30, qrcodeReqTime = 1} = loginForm
        const { cacheAccount: loginId, langId } = state;
        portalLoginStore.getLoginForm({ loginId, langId }, () => portalLoginStore.onQCLoginStart(qrcodeValidTime,qrcodeReqTime));
    }

    componentWillUnmount() {
        const { portalLoginStore } = this.props;
        portalLoginStore.onQCLoginEnd();
    }

    render() {
        const { portalLoginStore, getState } = this.props;
        let { qrcodeIsInvalid, emobileDownloadUrl, state = {}, labelObj } = portalLoginStore;
        state = getState();
        const { loginSettingInfo = {}, qrCode } = state;
        const { loginForm = {} } = loginSettingInfo;

        const size = this.props.size || 100;
        const color = this.props.color || loginForm.color || '#fff';

        return (
            <div className="simplelogin-QRCode">
                <div className="simplelogin-QRCode-area">
                    {qrcodeIsInvalid && (
                        <div className="simplelogin-QRCode-timeout">
                            <div className="simplelogin-QRCode-timeout-mask" />
                            <div className="simplelogin-QRCode-timeout-tips">{labelObj.qrcodeisinvalid}</div>
                            <i className="icon-coms-Refresh simplelogin-QRCode-timeout-refresh" title={labelObj.refresh} onClick={this.onRefresh} />
                        </div>
                    )}
                    {qrCode.text ? <QRCode ecId={`${this && this.props && this.props.ecId || ''}_QRCode@p6brx0`} value={qrCode.text} size={size} fgColor="#404549" bgColor="#eaeaea" /> : ''}
                </div>
                <div className="simplelogin-QRCode-describe" style={{ color }}>{labelObj.qrcode}</div>
                {emobileDownloadUrl && <div className="simplelogin-QRCode-download" onClick={this.onDownload}>{labelObj.download}</div>}
            </div>
        );
    }

    onRefresh() {
        const { portalLoginStore,getState } = this.props;
        let { state = {} } = portalLoginStore;
        state = getState();
        const { loginSettingInfo = {} } = state;
        const { loginInfo, loginForm } = loginSettingInfo;
        const {qrcodeValidTime = 30, qrcodeReqTime = 1} = loginForm
        const { cacheAccount: loginId, langId } = state;
        portalLoginStore.getLoginForm({ loginId, langId }, () => portalLoginStore.onQCLoginStart(qrcodeValidTime,qrcodeReqTime));
    }

    onDownload() {
        const { portalLoginStore } = this.props;
        const { emobileDownloadUrl } = portalLoginStore;
        window.open(addContentPath(emobileDownloadUrl));
    }
}

export default SimpleQRCode;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/login/simpleLogin/formCloud/qRCode.js